import { useState } from 'react'
import { useSelector } from 'react-redux'

// antd
import {
    Col,
    Divider,
    Image,
    Row,
    Space,
    Spin,
    Tag,
    Typography,
    theme,
} from 'antd'

// components
import ModalProfile from '../../../components/modal'

// slices
import { profileState } from '../profile.slice'

// assets
import {
    ExperienceIcon,
    ExperienceLogoIcon,
    NoExperienceIcon,
} from '../../../assets/icons'

// tab
import NoIndividualContent from '../tabSection/noIndividualContent'

// constants

// modals
import ViewMediaModal from './viewMediaModal'

// styles
import styles from '../profile.module.css'
import tabStyles from '../profileTabContent.module.css'
import { formatMonthYear } from '../../../utils/commonUtils'

function ExperienceTabContent() {
    const { Title, Text } = Typography

    const { useToken } = theme
    const { token } = useToken()
    const [viewMediaModalExperience, setViewMediaModalExperience] = useState({
        open: false,
        fileName: '',
    })

    const {
        profileData: {
            data: { experience },
        },
        status,
    } = useSelector(profileState)

    return (
        <>
            <div className={`${tabStyles.panel} ${tabStyles.hideDivider}`}>
                <Row align="middle" justify={'space-between'}>
                    <Title level={4} className={tabStyles.panelTitle}>
                        Experience
                    </Title>
                    {/* {userProfile?.role?.roleName !== SUPER_ADMIN && (
                        <Button
                            props={{
                                text: 'Add Experience',
                                onClick: () => {
                                    dispatch(
                                        switchProfileModal({
                                            name: 'experience',
                                            open: true,
                                        })
                                    )
                                },
                            }}
                        />
                    )} */}
                </Row>
                <Spin spinning={status === 'loading' ? true : false}>
                    {status === 'loaded' && experience?.length > 0 ? (
                        experience.map((experienceData, index) => (
                            <div
                                className={tabStyles.itemCard}
                                key={
                                    experienceData?._id ||
                                    experienceData?.companyName?.name ||
                                    index
                                }
                            >
                                <Row
                                    justify={'space-between'}
                                    style={{
                                        width: '100%',
                                    }}
                                >
                                    <Col span={23}>
                                        <div className={tabStyles.itemMain}>
                                            <div className={tabStyles.logoBox}>
                                                {experienceData?.companyName
                                                    ?.logo ? (
                                                    <Image
                                                        src={
                                                            experienceData
                                                                ?.companyName
                                                                ?.logo
                                                        }
                                                        width={'100%'}
                                                        height={'100%'}
                                                        preview={false}
                                                    />
                                                ) : (
                                                    <ExperienceLogoIcon />
                                                )}
                                            </div>

                                            <div className={tabStyles.itemBody}>
                                                <Row>
                                                    <Space>
                                                        {experienceData?.title && (
                                                            <Title
                                                                className={
                                                                    'titleSub'
                                                                }
                                                            >
                                                                {
                                                                    experienceData?.title
                                                                }
                                                            </Title>
                                                        )}
                                                        <Text className="titleLight">
                                                            {!experienceData?.isCompleted &&
                                                                `(Draft)`}
                                                        </Text>
                                                    </Space>
                                                </Row>
                                                <Space>
                                                    {experienceData?.companyName
                                                        ?.name && (
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSize,
                                                            }}
                                                        >
                                                            {
                                                                experienceData
                                                                    ?.companyName
                                                                    ?.name
                                                            }
                                                        </Text>
                                                    )}
                                                    {experienceData?.companyName
                                                        ?.name &&
                                                        experienceData?.location &&
                                                        '|'}
                                                    {experienceData?.location && (
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSize,
                                                            }}
                                                        >
                                                            {
                                                                experienceData?.location
                                                            }
                                                        </Text>
                                                    )}
                                                </Space>
                                                <Space>
                                                    {(() => {
                                                        const startLabel =
                                                            formatMonthYear(
                                                                experienceData?.start
                                                            )
                                                        const endLabel =
                                                            experienceData?.currentlyWorking
                                                                ? 'Present'
                                                                : formatMonthYear(
                                                                      experienceData?.end
                                                                  )
                                                        if (
                                                            !startLabel &&
                                                            !endLabel
                                                        )
                                                            return null
                                                        return (
                                                            <>
                                                                {startLabel ? (
                                                                    <Text
                                                                        style={{
                                                                            fontSize:
                                                                                token.fontSizeLG,
                                                                        }}
                                                                        className={
                                                                            'titleLight'
                                                                        }
                                                                    >
                                                                        {
                                                                            startLabel
                                                                        }
                                                                    </Text>
                                                                ) : null}
                                                                {startLabel &&
                                                                endLabel
                                                                    ? '-'
                                                                    : null}
                                                                {endLabel ? (
                                                                    <Text
                                                                        style={{
                                                                            fontSize:
                                                                                token.fontSizeLG,
                                                                        }}
                                                                        className={
                                                                            'titleLight'
                                                                        }
                                                                    >
                                                                        {
                                                                            endLabel
                                                                        }
                                                                    </Text>
                                                                ) : null}
                                                            </>
                                                        )
                                                    })()}
                                                </Space>
                                                {experienceData?.skills
                                                    ?.length > 0 && (
                                                    <div>
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSizeLG,
                                                                fontWeight:
                                                                    token.fontWeightStrong,
                                                            }}
                                                        >
                                                            Skills
                                                        </Text>
                                                        <div
                                                            className={
                                                                tabStyles.tagWrap
                                                            }
                                                        >
                                                            {experienceData?.skills.map(
                                                                (skill) => (
                                                                    <Tag
                                                                        key={
                                                                            skill?.name
                                                                        }
                                                                        color={
                                                                            token
                                                                                .colorPalette
                                                                                .baseColor
                                                                                .senary
                                                                        }
                                                                    >
                                                                        <Text
                                                                            style={{
                                                                                fontWeight:
                                                                                    token.fontWeightStrong,
                                                                            }}
                                                                        >
                                                                            {skill?.name?.toUpperCase()}
                                                                        </Text>
                                                                    </Tag>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                {experienceData?.tools?.length >
                                                    0 && (
                                                    <div>
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSizeLG,
                                                                fontWeight:
                                                                    token.fontWeightStrong,
                                                            }}
                                                        >
                                                            Tools
                                                        </Text>
                                                        <Row
                                                            style={{
                                                                columnGap:
                                                                    '15px',
                                                                marginTop:
                                                                    '8px',
                                                            }}
                                                        >
                                                            {experienceData?.tools.map(
                                                                (tool) => (
                                                                    <div
                                                                        key={
                                                                            tool?.label
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                styles.toolIconDefault
                                                                            }
                                                                            style={{
                                                                                border: `2px solid ${token.colorPalette.baseColor.tertiary}`,
                                                                            }}
                                                                        >
                                                                            <Image
                                                                                src={
                                                                                    tool?.logo
                                                                                }
                                                                                preview={
                                                                                    false
                                                                                }
                                                                                width={
                                                                                    '100%'
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            style={{
                                                                                width: '60px',
                                                                                whiteSpace:
                                                                                    'nowrap',
                                                                                overflow:
                                                                                    'hidden',
                                                                                textOverflow:
                                                                                    'ellipsis',
                                                                            }}
                                                                        >
                                                                            <Text
                                                                                style={{
                                                                                    marginTop:
                                                                                        '2px',
                                                                                    fontWeight:
                                                                                        token.fontWeightStrong,
                                                                                    textTransform:
                                                                                        'capitalize',
                                                                                }}
                                                                            >
                                                                                {
                                                                                    tool?.name
                                                                                }
                                                                            </Text>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                        </Row>
                                                    </div>
                                                )}
                                                {experienceData?.fileLink
                                                    ?.length > 0 && (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            rowGap: '5px',
                                                        }}
                                                    >
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSizeLG,
                                                                fontWeight:
                                                                    token.fontWeightStrong,
                                                            }}
                                                        >
                                                            Media
                                                        </Text>
                                                        <Row
                                                            align={'top'}
                                                            style={{
                                                                columnGap:
                                                                    '18px',
                                                            }}
                                                        >
                                                            <video
                                                                src={
                                                                    experienceData?.fileLink
                                                                }
                                                                width={'194px'}
                                                                height={'110px'}
                                                                style={{
                                                                    objectFit:
                                                                        'cover',
                                                                    borderRadius:
                                                                        '15px',
                                                                    cursor: 'pointer',
                                                                }}
                                                                preview={false}
                                                                onClick={() => {
                                                                    setViewMediaModalExperience(
                                                                        {
                                                                            open: true,
                                                                            fileName:
                                                                                experienceData?.fileLink,
                                                                        }
                                                                    )
                                                                }}
                                                            />
                                                            <div>
                                                                {experienceData?.fileTitle && (
                                                                    <Title
                                                                        level={
                                                                            5
                                                                        }
                                                                    >
                                                                        {
                                                                            experienceData?.fileTitle
                                                                        }
                                                                    </Title>
                                                                )}
                                                                {experienceData?.description && (
                                                                    <Text>
                                                                        {
                                                                            experienceData?.description
                                                                        }
                                                                    </Text>
                                                                )}
                                                            </div>
                                                        </Row>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    {/* <Col span={1}>
                                        {userProfile?.role?.roleName !==
                                            SUPER_ADMIN && (
                                            <div
                                                className={tabStyles.editBtn}
                                                onClick={() => {
                                                    dispatch(
                                                        setDeleteModalTitle(
                                                            'experience'
                                                        )
                                                    )
                                                    dispatch(
                                                        switchProfileModal({
                                                            name: 'experience',
                                                            open: true,
                                                            mode: 'edit',
                                                        })
                                                    )
                                                    dispatch(
                                                        updatedDataProfile({
                                                            editData: {
                                                                step: 'experience',
                                                                stepField:
                                                                    '_id',
                                                                stepFieldValue:
                                                                    experienceData?._id,
                                                            },
                                                            _id: userProfile?._id,
                                                        })
                                                    )
                                                }}
                                            >
                                                <EditIcon />
                                            </div>
                                        )}
                                    </Col> */}
                                </Row>
                                {experience?.length - 1 !== index && (
                                    <Divider />
                                )}
                            </div>
                        ))
                    ) : status === 'loaded' ? (
                        <NoIndividualContent
                            content={{
                                key: 'experience',
                                title: 'Experience',
                                icon: <NoExperienceIcon />,
                            }}
                        />
                    ) : (
                        status === 'loading' && <Spin />
                    )}
                </Spin>
            </div>
            <ModalProfile
                visibility={viewMediaModalExperience.open}
                handleCancel={() => {
                    setViewMediaModalExperience({
                        open: false,
                        fileName: '',
                    })
                }}
                icon={<ExperienceIcon />}
                modalKey="viewVideo"
                modalTitle="Media"
                showTitle="Media"
                footer={false}
                content={
                    <ViewMediaModal
                        fileName={viewMediaModalExperience?.fileName}
                    />
                }
            />
        </>
    )
}

export default ExperienceTabContent
